import context from '../context'
import { allowErrorDialog } from '@/utils/fetch'

export const initialState = {
  fetching: false,
  configuring: false,
  toggling: false,
  providerUpdating: false,
  authenticatorFetching: false,
  authenticatorRemoving: false,
  twoFactor: null
}

export const actionTypes = {
  fetching: 'twoFactorAuth/fetching',
  fetched: 'twoFactorAuth/fetched',
  configuring: 'twoFactorAuth/configuring',
  configured: 'twoFactorAuth/configured',
  toggling: 'twoFactorAuth/toggling',
  toggled: 'twoFactorAuth/toggled',
  providerUpdating: 'twoFactorAuth/providerUpdating',
  providerUpdated: 'twoFactorAuth/providerUpdated',
  authenticatorFetching: 'twoFactorAuth/authenticatorFetching',
  authenticatorFetched: 'twoFactorAuth/authenticatorFetched',
  authenticatorRemoving: 'twoFactorAuth/authenticatorRemoving',
  authenticatorRemoved: 'twoFactorAuth/authenticatorRemoved',
  error: 'twoFactorAuth/error'
}

export const actionCreators = {
  getTwoFactorInfo: () => (dispatch) => {
    dispatch({ type: actionTypes.fetching })
    context.api.userProfile.getTwoFactorInfo(allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.fetched, payload: response })
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { fetching: false } }))
  },
  getAuthenticatorDetails: () => (dispatch) => {
    dispatch({ type: actionTypes.authenticatorFetching })
    context.api.userProfile.getAuthenticatorDetails(allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.authenticatorFetched, payload: response })
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { authenticatorFetching: false } }))
  },
  toggleTwoFactorAuthentication: () => (dispatch) => {
    dispatch({ type: actionTypes.toggling })
    context.api.userProfile.toggleTwoFactorAuthentication(allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.toggled })
        dispatch(actionCreators.getTwoFactorInfo())
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { toggling: false } }))
  },
  configureAuthenticator: () => (dispatch) => {
    dispatch({ type: actionTypes.configuring })
    context.api.userProfile.configureAuthenticator(allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.configured, payload: response })
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { configuring: false } }))
  },
  removeAuthenticatorConfiguration: () => (dispatch) => {
    dispatch({ type: actionTypes.authenticatorRemoving })
    context.api.userProfile.removeAuthenticatorConfiguration(allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.authenticatorRemoved })
        dispatch(actionCreators.getTwoFactorInfo())
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { authenticatorRemoving: false } }))
  },
  updatePreferredTwoFactorProvider: (provider) => (dispatch) => {
    dispatch({ type: actionTypes.providerUpdating })
    context.api.userProfile.updatePreferredTwoFactorProvider(provider, allowErrorDialog)
      .then(response => {
        const { availableTwoFactorProviders, preferredTwoFactorProvider } = response
        dispatch({ type: actionTypes.providerUpdated, payload: { availableTwoFactorProviders, preferredTwoFactorProvider } })
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { providerUpdating: false } }))
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.fetching: return { ...state, fetching: true }
    case actionTypes.fetched: return { ...state, fetching: false, twoFactor: action.payload }

    case actionTypes.toggling: return { ...state, toggling: true }
    case actionTypes.toggled: return { ...state, toggling: false }

    case actionTypes.configuring: return { ...state, configuring: true }
    case actionTypes.configured: return { ...state, configuring: false, twoFactor: action.payload }

    case actionTypes.providerUpdating: return { ...state, providerUpdating: true }
    case actionTypes.providerUpdated: return { ...state, providerUpdating: false, twoFactor: { ...state.twoFactor, ...action.payload } }

    case actionTypes.authenticatorFetching: return { ...state, authenticatorFetching: true }
    case actionTypes.authenticatorFetched: return { ...state, authenticatorFetching: false, twoFactor: { ...state.twoFactor, authenticatorDetails: action.payload } }

    case actionTypes.authenticatorRemoving: return { ...state, authenticatorRemoving: true }
    case actionTypes.authenticatorRemoved: return { ...state, authenticatorRemoving: false, twoFactor: { ...state.twoFactor, authenticatorDetails: null, isAuthenticatorConfigured: false } }

    case actionTypes.error: return { ...state, ...action.update }

    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/twoFactorAuth.js